
import {
    getActiveUsersRepo,
    getDeleteUserRepo,
    putDeleteUserRepo,
    delDeleteUserRepo,
} from "../repositories/premium/permission";
import { createSlice } from "@reduxjs/toolkit";

const deleteUserSlice = createSlice({
    name: "deleteUserSliceReducer",
    initialState: {

        activeUserListLoading: false,
        activeUserList: null,
        activeUserListError: null,

        deleteUserListLoading: false,
        deleteUserList: null,
        deleteUserListError: null,

        putDeleteUserLoading: false,
        putDeleteUser: null,
        putDeleteUserError: null,

        delDeleteUserLoading: false,
        delDeleteUser: null,
        delDeleteUserError: null,

        message:null,
        
    },
    reducers: {

        getActiveUserListLoading(state, action) {
            return {
                ...state,
                activeUserListLoading: true,
            };
        },
        getActiveUserListSuccess(state, action) {
            return {
                ...state,
                activeUserListLoading: false,
                activeUserList: action.payload,
            };
        },
        getActiveUserListFailure(state, action) {
            return {
                ...state,
                activeUserListLoading: false,
                activeUserListError: action.payload,
            };
        },

        getDeleteUserListLoading(state, action) {
            return {
                ...state,
                deleteUserListLoading: true,
            };
        },
        getDeleteUserListSuccess(state, action) {
            return {
                ...state,
                deleteUserListLoading: false,
                deleteUserList: action.payload,
            };
        },
        getDeleteUserListFailure(state, action) {
            return {
                ...state,
                deleteUserListLoading: false,
                deleteUserListError: action.payload,
            };
        },

        putDeleteUsersLoading(state, action) {
            return {
                ...state,
                putDeleteUserLoading: true,
            };
        },
        putDeleteUserSuccess(state, action) {
            return {
                ...state,
                putDeleteUserLoading: false,
                putDeleteUser: action.payload,
                message:'Records Updated Successfully',
            };
        },
        putDeleteUserFailure(state, action) {
            return {
                ...state,
                putDeleteUserLoading: false,
                putDeleteUserError: action.payload,
                message:action.payload,
            };
        },

        delDeleteUsersLoading(state, action) {
            return {
                ...state,
                delDeleteUserLoading: true,
            };
        },
        delDeleteUserSuccess(state, action) {
            return {
                ...state,
                delDeleteUserLoading: false,
                delDeleteUser: action.payload,
                message:action.payload,
            };
        },
        delDeleteUserFailure(state, action) {
            return {
                ...state,
                delDeleteUserLoading: false,
                delDeleteUserError: action.payload,
                message:action.payload,
            };
        },

        clearData(state, action) {
            return {
                ...state,
                message:null,
                deleteUserList: null,
                putDeleteUser:null,
                delDeleteUser:null,
                putDeleteUserError:null,
                delDeleteUserError:null,
            };
        },

        clearAssignneList(state, action) {
            return {
                ...state,
                deleteUserList: null,
            };
        },


        
    },
});
export const {

    getActiveUserListLoading,
    getActiveUserListSuccess,
    getActiveUserListFailure,

    getDeleteUserListLoading,
    getDeleteUserListSuccess,
    getDeleteUserListFailure,

    putDeleteUsersLoading,
    putDeleteUserSuccess,
    putDeleteUserFailure,

    delDeleteUsersLoading,
    delDeleteUserSuccess,
    delDeleteUserFailure,

    clearAssignneList,
    clearData,

} = deleteUserSlice.actions;


export const getActiveUserList = (params) => {
    return async (dispatch) => {
        dispatch(getActiveUserListLoading());
        await getActiveUsersRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300){
                    dispatch(getActiveUserListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getActiveUserListFailure(error.response?.message));
                }
            });
    };
};

export const getDeleteUserList = (id,params) => {
    return async (dispatch) => {
        dispatch(getDeleteUserListLoading());
        await getDeleteUserRepo(id,params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300){
                    dispatch(getDeleteUserListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDeleteUserListFailure(error.response?.message));
                }
            });
    };
};

export const putDeleteUsers = (id,params) => {
    return async (dispatch) => {
        dispatch(putDeleteUsersLoading());
        await putDeleteUserRepo(id,params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300){
                    dispatch(putDeleteUserSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putDeleteUserFailure(error.response?.message));
                }
            });
    };
};

export const delDeleteUsers = (id) => {
    return async (dispatch) => {
        dispatch(delDeleteUsersLoading());
        await delDeleteUserRepo(id)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300){
                    dispatch(delDeleteUserSuccess(response?.data?.message));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(delDeleteUserFailure(error.response?.message));
                }
            });
    };
};

export default deleteUserSlice.reducer;
